import { FuseLoadable } from '@fuse';

const SupportPageConfig = { routes: [{ path: '/support', component: FuseLoadable({ loader: () => import('./MaintenancePage') }) }] };

export default [SupportPageConfig];
